import { CircularProgress, Stack } from "@mui/material"
import { useGetTrainingVideos } from "api/sdk";
import { VideoMetadata } from "schemas";
interface TrainDropDownProps {
    id: any;
}

export const TrainDropDown = ({ id }: TrainDropDownProps) => {
    const { data: trainingData, refetch: re, isLoading } = useGetTrainingVideos(id);
    console.log("data", trainingData)
    const styleHeaderCell = {
        width: '25%',
        padding: '12px',
        minHeight: '60px'
    };

    const styleContainerCell = {
        width: '25%',
        padding: '12px',
        minHeight: '50px'
    };

    const breakStyle = {
        width: '1px',
        height: '40px',
        backgroundColor: '#E0E0E0'
    };

    const formatDate = (dateString: string) => {
        const date = new Date(dateString);
        return date.toLocaleDateString();
    };

    const formatTime = (dateString: string) => {
        const date = new Date(dateString);
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    const formatDuration = (seconds: number) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
    };
    return isLoading ? (
        <div className="flex justify-center pt-[10px]">
            <CircularProgress className="w-[1vw]" />
        </div>
    ) : trainingData?.data.data.length === 0 ? (
        <p className="text-[1vw] flex justify-center items-center pt-[10px]">
            No Data Found!
        </p>) :

        (
            <Stack direction="column">



                {/* Header Row */}
                <Stack
                    direction="row"
                    gap={2}
                    alignItems="center"
                    justifyContent="space-between"
                    className="mb-1 bg-[#102633]"
                >
                    <Stack
                        direction="column"
                        alignItems="center"
                        justifyContent="center"
                        sx={styleHeaderCell}
                    >
                        <p className="text-[1vw] text-white">Video Name</p>
                    </Stack>
                    <div style={breakStyle}></div>

                    <Stack
                        direction="column"
                        alignItems="center"
                        justifyContent="center"
                        sx={styleHeaderCell}
                    >
                        <p className="text-[1vw] text-white">Duration</p>
                    </Stack>
                    <div style={breakStyle}></div>

                    <Stack
                        direction="column"
                        alignItems="center"
                        justifyContent="center"
                        sx={styleHeaderCell}
                    >
                        <p className="text-[1vw] text-white">Uploaded Date</p>
                    </Stack>
                    <div style={breakStyle}></div>

                    <Stack
                        direction="column"
                        alignItems="center"
                        justifyContent="center"
                        sx={styleHeaderCell}
                    >
                        <p className="text-[1vw] text-white">Uploaded Time</p>
                    </Stack>
                </Stack>

                {trainingData?.data.data.map((video: any) => (
                    <Stack
                        direction="row"
                        gap={2}
                        alignItems="center"
                        justifyContent="space-between"
                        className="mb-1 bg-[#EEEEEE]"
                    >
                        <Stack
                            direction="column"
                            alignItems="center"
                            justifyContent="center"
                            sx={styleContainerCell}
                        >
                            <p className="text-[0.8vw] text-[#102633]">{video.file_name}</p>
                        </Stack>
                        <div style={breakStyle}></div>

                        <Stack
                            direction="column"
                            alignItems="center"
                            justifyContent="center"
                            sx={styleContainerCell}
                        >
                            <p className="text-[0.8vw] text-[#102633]">{formatDuration(video.metadata.duration)}</p>
                        </Stack>
                        <div style={breakStyle}></div>

                        <Stack
                            direction="column"
                            alignItems="center"
                            justifyContent="center"
                            sx={styleContainerCell}
                        >
                            <p className="text-[0.8vw] text-[#102633]">{formatDate(video.uploaded_at)}</p>
                        </Stack>
                        <div style={breakStyle}></div>

                        <Stack
                            direction="column"
                            alignItems="center"
                            justifyContent="center"
                            sx={styleContainerCell}
                        >
                            <p className="text-[0.8vw] text-[#102633]">{formatTime(video.uploaded_at)}</p>
                        </Stack>
                    </Stack>
                ))}


            </Stack>
        )
}

// trainingData?.data.data.length ===0?(
//     <p className="text-[1vw] flex justify-center items-center pt-[10px]">
//     No Data Found !
//   </p>